<div class="toastr-container" [class.mobile]="isMobile">
  <app-toast-item
    *ngFor="let toast of toasts; trackBy: trackByFn"
    [toast]="toast"
    (close)="onToastClose($event)"
  ></app-toast-item>
</div> 